module.exports = __webpack_public_path__ + "img/ic_profile_wizard_personal_info.e520464a.svg";